import joinClassNames from './joinClassNames.js'

/** Flat surface + border. Do not add a gradient identity stripe on cards. */
export default function Card({ className = '', ...props }) {
  return <div className={joinClassNames('card', className)} {...props} />
}

/** Section header row inside a Card (maps to `.card-title` in index.css). */
export function CardTitle({ as, className = '', ...props }) {
  const Tag = as ?? 'div'
  return <Tag className={joinClassNames('card-title', className)} {...props} />
}

/** Main content area below CardTitle (maps to `.card-body`). */
export function CardBody({ className = '', ...props }) {
  return <div className={joinClassNames('card-body', className)} {...props} />
}
